import Button from 'molecules/Button';

import MiniCallOutCard from 'layout/header/components/MiniCallOutCard';
import { closeMenu } from 'layout/header/store';
import { calloutCardContainer } from 'layout/header/styles';

import { hasArrayValues } from 'utils/array/arrays';

import type { FC } from 'react';

const CallOutCard: FC<HeaderCallOutCard> = ({ heading, description, buttons, miniCallOuts, link }) => (
  <div className={calloutCardContainer}>
    {(heading || description) && (
      <div className="flex w-full flex-col gap-3 sm:w-1/2 sm:max-w-md xl:w-full">
        {heading && (
          <div className="flex items-center gap-2">
            {link ? (
              <Button
                href={link}
                label={heading}
                hierarchy="linkGray"
                endIcon="arrow-up-right"
                className="inline-flex items-center gap-2 p-0 font-spaceGrotesk !text-lg font-semibold leading-7 text-white"
                onClick={() => closeMenu()}
              />
            ) : (
              <span className="font-spaceGrotesk text-lg font-semibold leading-7 text-white">{heading}</span>
            )}
          </div>
        )}
        <span className="mt-2 block text-sm leading-5 text-gray-300">{description}</span>{' '}
        {hasArrayValues(buttons) && (
          <div className="mt-4 flex flex-col gap-2 lg:mt-8 xl:mt-10">
            {buttons.map(button => (
              <Button
                key={button.label}
                label={button.label}
                href={button.link}
                hierarchy="linkGray"
                className="w-fit text-sm font-semibold"
                endIcon="arrow-up-right"
                onClick={() => closeMenu()}
              />
            ))}
          </div>
        )}
      </div>
    )}
    {hasArrayValues(miniCallOuts) &&
      miniCallOuts.map(miniCallOut => <MiniCallOutCard {...miniCallOut} context="inside" key={miniCallOut.heading} />)}
  </div>
);

export default CallOutCard;
